export default __webpack_public_path__ + "i18n/de.c87283af9cf7f279cba2d4a8698da0f8.json";